export const MAIN_CLASS = 'main';
export const COMMENT_HIGHLIGHTED = 'comment--highlighted';
